export class AppSelect extends HTMLElement {
    private originalContent: string = "";

    constructor() {
        super();
    }

    connectedCallback() {
        // Al igual que con el checkbox, guardamos las etiquetas <option> originales
        if (!this.originalContent) {
            this.originalContent = this.innerHTML.trim();
        }
        this.render();
    }

    static get observedAttributes() {
        return ['label', 'formControlName'];
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue && this.originalContent) {
            this.render();
        }
    }

    render() {
        const label = this.getAttribute("label") || "";
        const controlName = this.getAttribute("formControlName") || "";

        this.innerHTML = `
            ${label ? `<label class="form-label">${label}</label>` : ''}
            <select 
                ${controlName ? `formControlName="${controlName}"` : ''} 
                class="form-input cursor-pointer"
            >
                ${this.originalContent}
            </select>
            ${controlName ? `<span formErrorFor="${controlName}" class="text-red-600 text-xs font-medium block min-h-[1.25rem] px-1 transition-all duration-150"></span>` : ''}
        `;
    }
}

// Registrar el Web Component en el navegador
if (typeof window !== 'undefined') {
    customElements.define('app-select', AppSelect);
}
